import { useUserInfo } from "@next-platform/client-common-core";
import {
  SubCapabilityKey,
  useApplicationCapabilitiesAllowed,
} from "@next-platform/client-common-core/infra/application/capabilities";
import { lazy } from "react";

import { ExploreLorebookCTA, ScrollBackToTop, SearchClientCharacterListing } from "@/components";
import PageStaticMetaTags from "@/components/common/PageStaticMetaTags";
import { FEATURE_FLAGS } from "@/constants";
import { useFeatureFlag } from "@/hooks";

let DebugMenu: ReturnType<typeof lazy> | null = null;
if (!IS_PRODUCTION_MODE) {
  DebugMenu = lazy(() => import("@/debug/DebugMenu"));
}

export default function Home() {
  const { roles } = useUserInfo();

  // The CTA links to the public lorebooks page, so gate it on the same
  // flag + capability that guard that route (see routes.tsx / Navigation).
  const { hasFeatureFlag: hasLorebookDiscoverPublic } = useFeatureFlag(FEATURE_FLAGS.LOREBOOK_DISCOVER_PUBLIC);
  const isLorebookPublicDiscoveryAllowed = useApplicationCapabilitiesAllowed(SubCapabilityKey.LorebookPublicDiscovery);
  const isEmployee = roles?.includes("employee");

  return (
    <>
      <PageStaticMetaTags pageId="home" />
      {isEmployee && DebugMenu ? <DebugMenu /> : null}
      <SearchClientCharacterListing />
      {hasLorebookDiscoverPublic && isLorebookPublicDiscoveryAllowed ? (
        <div data-testid="ExploreLorebookCTA" className="contents">
          <ExploreLorebookCTA />
        </div>
      ) : null}
      <ScrollBackToTop />
    </>
  );
}
